import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=18ded48b"
import script from "./PhoneField.vue?vue&type=script&lang=js"
export * from "./PhoneField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports